/// <amd-module name="TFS/Admin/Views/AdminHub/AdminHubBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";
import { FastPageSwitch } from "VSS/Platform/FPS";

export class AdminHubBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setSelectedPivotBreadcrumb(name: string, url?: string) {
        this.items.value = [
            {
                key: "SelectedPivot",
                text: name,
                rank: 50,
                onClick: url
                    ? () => {
                          FastPageSwitch(this.pageContext, url, true);
                      }
                    : undefined
            }
        ];
    }
}

Services.add("admin-hub-header-breadcrumb-service", { serviceFactory: AdminHubBreadcrumbService });
